import React, { useEffect } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { useProperties } from '@atlassian/jira-help-center-custom-domain-change-boarding/src/services/use-properties/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const PERIOD_TO_SHOW_LOZENGE_IN_DAYS = 21;

export const JsmCustomDomainLozenge = () => {
	const { formatMessage } = useIntl();
	const [{ showFlagUpdateStartDate, loading, error }, { fetchApplicationProperty }] =
		useProperties();

	useEffect(() => {
		fetchApplicationProperty();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const currentTime = Date.now();
	const customDomainUpdatedDate: Date | null =
		typeof showFlagUpdateStartDate === 'number' ? new Date(showFlagUpdateStartDate) : null;
	const stopShowLozengeTimestamp: number | null =
		customDomainUpdatedDate &&
		customDomainUpdatedDate.setDate(
			customDomainUpdatedDate.getDate() + PERIOD_TO_SHOW_LOZENGE_IN_DAYS,
		);
	const showLozenge =
		customDomainUpdatedDate && stopShowLozengeTimestamp
			? currentTime < stopShowLozengeTimestamp
			: false;

	return !error && !loading && showLozenge ? (
		<Lozenge appearance="new">{formatMessage(messages.helpCenterLozenge)}</Lozenge>
	) : null;
};
